import React from 'react';
import {TableProps} from './TableTypes';
import {DropdownButton} from '../Dropdown';
import {SystemIcons} from '../icons';
import {Size} from '../types';
import {
  StyledTableHeaderTitleContent
} from './TableStyles';
import {StyledTableHeaderTitle, StyledTableHeader} from "./TableStyles";


interface TableHeaderProps extends TableProps {
}

const TableHeader: React.FunctionComponent<TableHeaderProps> = props => {

  return (
    <StyledTableHeader>
      {
        (!!props.title || !!props.menu) &&
        <StyledTableHeaderTitle data-testid="TestTableHeaderRow">
            <StyledTableHeaderTitleContent>
              <span>{props.title}</span>
              {
                props.menu &&
                <DropdownButton className={'title-menu'}
                                type={'icon'}
                                disabled={props.showLoadingIndicator}
                                icon={<SystemIcons.MoreVertical/>}
                                size={Size.Medium} {...props.menu}/>
              }
            </StyledTableHeaderTitleContent>
        </StyledTableHeaderTitle>
      }
    </StyledTableHeader>
  )
}

export default TableHeader;
